"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClass = addClass;
exports.byteLength = byteLength;
exports.cleanArray = cleanArray;
exports.countryList = void 0;
exports.createUniqueString = createUniqueString;
exports.debounce = debounce;
exports.deepClone = deepClone;
exports.formatDates = formatDates;
exports.formatTime = formatTime;
exports.getQueryObject = getQueryObject;
exports.getTime = getTime;
exports.hasClass = hasClass;
exports.html2Text = html2Text;
exports.isWriteOff = isWriteOff;
exports.objectMerge = objectMerge;
exports.param = param;
exports.param2Obj = param2Obj;
exports.parseQuery = parseQuery;
exports.parseTime = parseTime;
exports.preFixxUrl = void 0;
exports.removeClass = removeClass;
exports.toggleClass = toggleClass;
exports.uniqueArr = uniqueArr;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * Created by PanJiaChen on 16/11/18.
 */
/**
 * Parse the time to string
 * @param {(Object|string|number)} date
 * @param {string} fmt
 * @returns {string | null}
 */
function formatDates(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

/**
 * 更改时间格式成2010-01-10格式
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        time = parseInt(time);
      } else {
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
function objectMerge(target, source) {
  if (_typeof(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if (_typeof(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone(source) {
  if (!source && _typeof(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && _typeof(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/**
 * 判断地址
 */
function parseQuery() {
  var res = {};
  var query = (location.href.split("?")[1] || "").trim().replace(/^(\?|#|&)/, "");
  if (!query) {
    return res;
  }
  query.split("&").forEach(function (param) {
    var parts = param.replace(/\+/g, " ").split("=");
    var key = decodeURIComponent(parts.shift());
    var val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;
    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });
  return res;
}

/**
 * 是否是核销员
 */
function isWriteOff() {
  if (localStorage.getItem('storeStaffList')) {
    var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    var staff = JSON.parse(localStorage.getItem('storeStaffList'));
    return staff.some(function (item) {
      return item.avatar === JavaInfo.account;
    });
  }
}
var countryList = [{
  value: "中国",
  label: "中国"
},
// 
{
  value: "蒙古",
  label: "蒙古"
}, {
  value: "朝鲜",
  label: "朝鲜"
},
// 
{
  value: "韩国",
  label: "韩国"
},
// 
{
  value: "日本",
  label: "日本"
},
// 
{
  value: "菲律宾",
  label: "菲律宾"
},
// 
{
  value: "越南",
  label: "越南"
},
// 
{
  value: "老挝",
  label: "老挝"
},
// 
{
  value: "柬埔寨",
  label: "柬埔寨"
},
// 
{
  value: "缅甸",
  label: "缅甸"
},
// 
{
  value: "泰国",
  label: "泰国"
},
// 
{
  value: "马来西亚",
  label: "马来西亚"
},
// 
{
  value: "文莱",
  label: "文莱"
},
// 
{
  value: "新加坡",
  label: "新加坡"
},
// 
{
  value: "印度尼西亚",
  label: "印度尼西亚"
},
// 
{
  value: "东帝汶",
  label: "东帝汶"
},
// 
{
  value: "尼泊尔",
  label: "尼泊尔"
},
// 
{
  value: "不丹",
  label: "不丹"
},
// 
{
  value: "孟加拉国",
  label: "孟加拉国"
},
// 
{
  value: "印度",
  label: "印度"
},
// 
{
  value: "巴基斯坦",
  label: "巴基斯坦"
}, {
  value: "斯里兰卡",
  label: "斯里兰卡"
},
// 
{
  value: "马尔代夫",
  label: "马尔代夫"
},
// 
{
  value: "哈萨克斯坦",
  label: "哈萨克斯坦"
},
// 
{
  value: "吉尔吉斯斯坦",
  label: "吉尔吉斯斯坦"
}, {
  value: "塔吉克斯坦",
  label: "塔吉克斯坦"
},
// 
{
  value: "乌兹别克斯坦",
  label: "乌兹别克斯坦"
},
// 
{
  value: "土库曼斯坦",
  label: "土库曼斯坦"
},
// 
{
  value: "阿富汗",
  label: "阿富汗"
},
// 
{
  value: "伊拉克",
  label: "伊拉克"
},
// 
{
  value: "伊朗",
  label: "伊朗"
},
// 
{
  value: "叙利亚",
  label: "叙利亚"
},
// 
{
  value: "约旦",
  label: "约旦"
},
// 
{
  value: "黎巴嫩",
  label: "黎巴嫩"
},
// 
{
  value: "以色列",
  label: "以色列"
}, {
  value: "巴勒斯坦",
  label: "巴勒斯坦"
},
// 
{
  value: "沙特阿拉伯",
  label: "沙特阿拉伯"
},
// 
{
  value: "巴林",
  label: "巴林"
},
// 
{
  value: "卡塔尔",
  label: "卡塔尔"
}, {
  value: "科威特",
  label: "科威特"
},
// 
{
  value: "阿拉伯联合酋长国",
  label: "阿拉伯联合酋长国"
},
// 
{
  value: "阿曼",
  label: "阿曼"
},
// 
{
  value: "也门",
  label: "也门"
},
// 
{
  value: "格鲁吉亚",
  label: "格鲁吉亚"
},
// 
{
  value: "亚美尼亚",
  label: "亚美尼亚"
},
// 
{
  value: "阿塞拜疆",
  label: "阿塞拜疆"
},
// 
{
  value: "土耳其",
  label: "土耳其"
},
// 
{
  value: "塞浦路斯",
  label: "塞浦路斯"
},
// 
{
  value: "芬兰",
  label: "芬兰"
},
// 
{
  value: "瑞典",
  label: "瑞典"
},
// 
{
  value: "挪威",
  label: "挪威"
},
// 
{
  value: "冰岛",
  label: "冰岛"
},
// 
{
  value: "爱沙尼亚",
  label: "爱沙尼亚"
},
// 
{
  value: "拉脱维亚",
  label: "拉脱维亚"
},
// 
{
  value: "立陶宛",
  label: "立陶宛"
},
// 
{
  value: "摩尔多瓦",
  label: "摩尔多瓦"
},
// 
{
  value: "白俄罗斯",
  label: "白俄罗斯"
},
// 
{
  value: "俄罗斯",
  label: "俄罗斯"
},
// 
{
  value: "乌克兰",
  label: "乌克兰"
},
// 
{
  value: "波兰",
  label: "波兰"
},
// 
{
  value: "捷克共和国",
  label: "捷克共和国"
},
// 
{
  value: "斯洛伐克",
  label: "斯洛伐克"
},
// 
{
  value: "匈牙利",
  label: "匈牙利"
},
// 
{
  value: "德国",
  label: "德国"
},
// 
{
  value: "奥地利",
  label: "奥地利"
},
// 
{
  value: "瑞士",
  label: "瑞士"
},
// 
{
  value: "列支敦士登",
  label: "列支敦士登"
},
// 
{
  value: "英国",
  label: "英国"
},
// 
{
  value: "爱尔兰",
  label: "爱尔兰"
},
// 
{
  value: "荷兰",
  label: "荷兰"
},
// 
{
  value: "比利时",
  label: "比利时"
},
// 
{
  value: "卢森堡",
  label: "卢森堡"
},
// 
{
  value: "法国",
  label: "法国"
},
// 
{
  value: "摩纳哥",
  label: "摩纳哥"
},
// 
{
  value: "罗马尼亚",
  label: "罗马尼亚"
},
// 
{
  value: "保加利亚",
  label: "保加利亚"
},
// 
{
  value: "塞尔维亚",
  label: "塞尔维亚"
},
// 
{
  value: "马其顿",
  label: "马其顿"
},
// 
{
  value: "斯洛文尼亚",
  label: "斯洛文尼亚"
}, {
  value: "克罗地亚",
  label: "克罗地亚"
},
// 
{
  value: "黑山共和国",
  label: "黑山共和国"
},
// 
{
  value: "波斯尼亚和黑塞哥维那",
  label: "波斯尼亚和黑塞哥维那"
},
// 
{
  value: "阿尔巴尼亚",
  label: "阿尔巴尼亚"
},
// 
{
  value: "希腊",
  label: "希腊"
},
// 
{
  value: "意大利",
  label: "意大利"
}, {
  value: "马耳他",
  label: "马耳他"
}, {
  value: "丹麦",
  label: "丹麦"
},
// 
{
  value: "梵蒂冈",
  label: "梵蒂冈"
},
// 
{
  value: "圣马力诺",
  label: "圣马力诺"
},
// 
{
  value: "西班牙",
  label: "西班牙"
},
// 
{
  value: "葡萄牙",
  label: "葡萄牙"
},
// 
{
  value: "安道尔共和国",
  label: "安道尔共和国"
}, {
  value: "加拿大",
  label: "加拿大"
},
// 
{
  value: "美国",
  label: "美国"
},
// 
{
  value: "墨西哥",
  label: "墨西哥"
}, {
  value: "危地马拉",
  label: "危地马拉"
}, {
  value: "伯利兹",
  label: "伯利兹"
}, {
  value: "古巴",
  label: "古巴"
},
// 
{
  value: "牙买加",
  label: "牙买加"
},
// 
{
  value: "海地",
  label: "海地"
}, {
  value: "哥伦比亚",
  label: "哥伦比亚"
},
// 
{
  value: "委内瑞拉",
  label: "委内瑞拉"
},
// 
{
  value: "圭亚那",
  label: "圭亚那"
},
// 
{
  value: "苏里南",
  label: "苏里南"
},
// 
{
  value: "厄瓜多尔",
  label: "厄瓜多尔"
},
// 
{
  value: "秘鲁",
  label: "秘鲁"
},
// 
{
  value: "巴西",
  label: "巴西"
},
// 
{
  value: "智利",
  label: "智利"
},
// 
{
  value: "阿根廷",
  label: "阿根廷"
},
// 
{
  value: "乌拉圭",
  label: "乌拉圭"
},
// 
{
  value: "巴拉圭",
  label: "巴拉圭"
}, {
  value: "澳大利亚",
  label: "澳大利亚"
}, {
  value: "新西兰",
  label: "新西兰"
}, {
  value: "帕劳",
  label: "帕劳"
}];
exports.countryList = countryList;
var preFixxUrl = function preFixxUrl(url) {
  if (url == 'http://dummyimage.com/400x400') {
    return url;
  } else {
    // return window.location.origin + '/'  + url;
    return process.env.VUE_APP_BASE_API + '/' + url;
  }
};
exports.preFixxUrl = preFixxUrl;